<template id="main">
  <Tree v-if="connected" :location-api="locationApi" :token="token" />
  <Login v-else :location-api="locationApi" :version="version" @connect="connect" />
</template>

<script>
import Tree from './components/Tree.vue'
import Login from './components/Login.vue'

export default {
  name: 'App',
  components: {
    Tree,
    Login,
  },
  data() {

    const version = '2.2.1';
    const locationApi = `${window.location.protocol}//${window.location.hostname}${process.env.VUE_APP_API_PORT}/apiphoto`;
//    const locationApi = `${window.location.protocol}//ha${process.env.VUE_APP_API_PORT}/apiphoto`;

    return {
      connected: false,
      token: '',
      locationApi,
      version,
    }
  },
  methods: {
    connect(token) {
      this.token = token;
      this.connected = true;
    }
  },
}
</script>

<style>
html {
   min-height: 100%;
   height: 100%;
}
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  margin: 0;
}
#app {
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  height: 100%;
}
#main {
  height: 100vh;
}
.logo {
  width: 50%;
}
.btn {
  margin-top: 100px;
}
</style>
